import Cookies from 'js-cookie'

const tokenKey = (sid) => {
  sid = getSid(sid)
  return sid ? `client-${sid}-token` : 'client-token'
}
const refreshTokenKey = (sid) => {
  sid = getSid(sid)
  return sid ? `client-${sid}-refreshToken` : 'client-refreshToken'
}
const expiresKey = (sid) => {
  sid = getSid(sid)
  return sid ? `client-${sid}-expires` : 'client-expires'
}
const clientImprove = (sid) => {
  sid = getSid(sid)
  return sid ? `client-${sid}-improve` : 'client-improve'
}
const improvePwd = (sid) => {
  sid = getSid(sid)
  return sid ? `improve-${sid}-pwd` : 'improve-pwd'
}
function getUrlKey(name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
}
function getSid(sid) {
  if (!sid) {
    if (location.href.indexOf('/anonymous/') >= 0) {
      // 匿名填报处理
      const hrefPart = location.href.split('/')
      sid = hrefPart[hrefPart.length - 2]
    } else {
      // 普通query参数处理
      sid = getUrlKey('sid') || getUrlKey('systemId')
    }
  }
  if (sid && sid.indexOf('-') > 0) {
    sid = sid.toUpperCase().split('-')[0]
  }
  return sid
}
export function setSolutionList(list) {
  const solutionList = []
  if (list && list.length) {
    list.forEach(item => {
      if (item && item.id) {
        solutionList.push({
          id: item.id.split('-')[0],
          fullId: item.id
        })
      }
    })
  }
  localStorage.setItem('solution-list', JSON.stringify(solutionList))
}
export function getToken(sid) {
  // 判断token有效期
  const expires = localStorage.getItem(expiresKey(sid))
  try {
    if (!expires || (expires && parseInt(expires) < parseInt(Date.now()))) {
      localStorage.removeItem(tokenKey(sid))
      localStorage.removeItem(refreshTokenKey(sid))
      localStorage.removeItem(expiresKey(sid))
    }
  } catch (ex) { console.error(ex) }
  return localStorage.getItem(tokenKey(sid))
}
export function getRefreshToken(sid) {
  return localStorage.getItem(refreshTokenKey())
}
export function getSolutionId() {
  var solutionList = localStorage.getItem('solution-list')
  if (solutionList) {
    try {
      solutionList = JSON.parse(solutionList)
    } catch (ex) {
      solutionList = []
    }
    const currentSolution = solutionList.find(s => s.id === getSid())
    if (currentSolution) {
      return currentSolution.fullId
    }
  }
  return localStorage.getItem('client-solutionId')
}
export function getExpires() {
  return localStorage.getItem(expiresKey())
}

export function setToken(token, refreshToken, expires, sid) {
  localStorage.setItem(tokenKey(sid), token, { expires: 7 })
  localStorage.setItem(refreshTokenKey(sid), refreshToken)
  localStorage.setItem(expiresKey(sid), expires)
}

export function removeToken() {
  localStorage.removeItem(tokenKey())
}

export function setImprove(improve, sid) {
  localStorage.setItem(clientImprove(sid), improve, { expires: 7 })
}

export function getImprove() {
  return localStorage.getItem(clientImprove())
}

export function setPWD(PWD) {
  localStorage.setItem(improvePwd(), PWD, { expires: 7 })
}

export function getPWD() {
  return localStorage.getItem(improvePwd())
}

export function setHash(val) {
  Cookies.set((getSolutionId() + '-hash'), JSON.stringify(val), { expires: 365 })
}
export function getHash(val) {
  const data = Cookies.get(getSolutionId() + '-hash')
  if (data) {
    if (val) {
      return JSON.parse(data)[val]
    } else {
      return JSON.parse(data)
    }
  } else {
    if (val) {
      return '0'
    } else {
      return undefined
    }
  }
}
